// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { sizeVariantValues } from "@eisinc/MobiusOverrides/FormField/formStyles";
import { productSelectorStyles } from "@eisinc/Overrides/Components/ProductSelector";
import { fontConfig } from "@eisinc/XDL/PreStyle/typography";
import { color, xScreen } from "@eisinc/XDL/Utilities";
import { FormInputWrapper } from "@insite/mobius/FormField";
import { css } from "styled-components";

productSelectorStyles.wrapper = {
    css: css`
        display: grid;
        grid-template-columns: minmax(328px, 1fr) minmax(0, 94px) minmax(0, 120px) minmax(0, 328px);
        grid-column-gap: 22px;
        align-items: flex-end;
        width: 100%;
        ${xScreen("lte", "md")} {
            grid-column-gap: 20px;
        }
        ${xScreen("lte", "sm")} {
            display: flex;
            flex-wrap: wrap;
            gap: 16px 20px;
            > div:first-child {
                width: 100%;
            }
            .uom-wrapper {
                flex-grow: 1;
            }
        }
    `,
};

productSelectorStyles.qtyfield = {
    wrapper: {
        css: css`
            height: ${sizeVariantValues.default.height}px;
        `,
    },
    editableQuantityTextField: {
        mergeCss: true,
        cssOverrides: {
            formInputWrapper: css`
                display: flex;
                align-items: center;
                height: 100%;
            `,
        },
    },
    qtyLabel: {
        ...fontConfig.singleLinexxSmall,
        css: css`
            display: block;
            margin-bottom: 4px;
        `,
    },
};

productSelectorStyles.clearIcon = {
    size: 16,
    css: css`
        position: absolute;
        right: 25px;
        top: 30px;
        cursor: pointer;
        &:hover {
            color: ${color("common.ui3")};
        }
    `,
};

productSelectorStyles.unitOfMeasureSelect = {
    mergeCss: true,
    sizeVariant: "default",
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
    },
    labelProps: {
        css: css`
            display: block;
            min-height: unset;
            &&& + ${FormInputWrapper} {
                margin-top: 4px;
            }
        `,
    },
};

productSelectorStyles.searchDynamicDropdown = {
    sizeVariant: "default",
    cssOverrides: {
        formField: css`
            width: 100%;
        `,
    },
};

productSelectorStyles.buttonWrapper = {
    css: css`
        display: flex;
        width: 100%;
        align-self: end;
    `,
};

productSelectorStyles.selectButton = {
    sizeVariant: "medium",
    typographyProps: {
        css: css`
            white-space: nowrap;
        `,
    },
    css: css`
        width: 100%;
    `,
};

productSelectorStyles.searchDropdownWrapper = {
    css: css`
        position: relative;
        display: flex;
    `,
};
